import React from 'react';

import GenericNpiLookupComponent from './GenericNpiLookupComponent';
import HarmonyNpiLookupComponent from './HarmonyNpiLookupComponent';
import MelintaNpiLookupComponent from './MelintaNpiLookupComponent';
import VericelNpiLookupComponent from './VericelNpiLookupComponent';
import SobiNpiLookupComponent from './SobiNpiLookupComponent';
import FmiNpiLookupComponent from './FmiNpiLookupComponent';

const npiLookupMapping = {
  harmony: HarmonyNpiLookupComponent,
  melinta: MelintaNpiLookupComponent,
  vericel: VericelNpiLookupComponent,
  sobi: SobiNpiLookupComponent,
  foundationmedicineinc: FmiNpiLookupComponent
};

const renderNpiComponent = (tenant) => {
  // console.log('renderNpiComponent tenant', tenant);
  const NpiLookupComponent = npiLookupMapping[tenant]
    ? npiLookupMapping[tenant]
    : GenericNpiLookupComponent;
  return <NpiLookupComponent />;
};

export default renderNpiComponent;
